import { getIsAQuoteTemplate } from 'Cube/domain/postActionStages/utils/getIsQuoteATemplate'
import {
  CubeReducerState,
  CubeStatus,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

export const getRevokeQuoteAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  if (getIsAQuoteTemplate(prevState)) {
    return {
      available: {
        visible: false,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.InvalidStatus,
          metadata: { status: prevState.data.common.status }
        }
      ]
    }
  }

  const isArchived: boolean = prevState.data.common.isArchived
  const isPublished: boolean =
    prevState.data.common.status === CubeStatus.QuotePublished

  const hasRevokableStatus = isPublished

  if (isArchived || !hasRevokableStatus) {
    return {
      available: {
        visible: false,
        enabled: false
      },
      reasons: []
    }
  }

  const isExpired = prevState.data.quote.isExpired

  if (isExpired) {
    return {
      available: {
        visible: false,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.CantChangeWhenExpired,
          metadata: { quote: prevState.data.quote }
        }
      ]
    }
  }

  return {
    available: {
      visible: true,
      enabled: true
    },
    reasons: []
  }
}
